/* eslint-disable react-hooks/exhaustive-deps */
import { Tag } from "antd";
import React from "react";
export const FullTextTag = (props) => {
  const { label, value, closable, onClose } = props;
  return (
    <Tag
      closable={closable}
      onClose={onClose}
      style={{
        maxWidth: "100%",
        whiteSpace: "normal",
        wordBreak: "break-word",
        marginRight: 4,
        background: "#f5f5f5",
        fontSize: 16,
        color: "#000000D9",
        lineHeight: "24px",
        padding: "0px 8px",
        display: "inline-flex",
        alignItems: "center",
        marginTop: 2,
      }}
    >
      {label}
    </Tag>
  );
};
